"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FooterMinimal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var bricks_1 = require("../../bricks");
var FooterMinimal = function (_a) {
    var copyright = _a.copyright, image = _a.image, facebook = _a.facebook, twitter = _a.twitter, linkedin = _a.linkedin, instagram = _a.instagram;
    return ((0, jsx_runtime_1.jsx)("footer", __assign({ className: "section-padding fw-light dark" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "container d-md-flex align-items-center" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "me-auto" }, { children: image && (0, jsx_runtime_1.jsx)("img", { src: image, style: { maxWidth: '120px', maxHeight: '40px' }, alt: "" }) })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "opacity-60 my-4 my-md-0 mx-md-4" }, { children: ["\u00A9 ", new Date().getFullYear(), " ", copyright] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "ms-auto" }, { children: (0, jsx_runtime_1.jsx)(bricks_1.Social, { facebook: facebook, twitter: twitter, linkedin: linkedin, instagram: instagram }) }))] })) })));
};
exports.FooterMinimal = FooterMinimal;
